import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DateLocalePipe } from '@modeso/aumico-lib-core-fe';
import { ReportType } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GeneralInformationMode } from '../../../enums/general-information-form-mode.enum';
import { DatesCalculatorUtil } from '../../../utils/dates.util';
import { GeneralInformationBaseComponent } from '../base/general-information-base.component';

@UntilDestroy()
@Component({
    selector: 'aumico-general-information-new',
    templateUrl: '../general-information-v2.component.html',
    styleUrls: ['../general-information-v2.component.scss'],
})
export class GeneralInformationNewComponent extends GeneralInformationBaseComponent implements OnInit, OnChanges {
    get mode(): GeneralInformationMode {
        return GeneralInformationMode.NEW;
    }

    // Getters specific to NEW mode
    get showAutofillFromPreviousForBalanceToggle(): boolean {
        return false; // No autofill options in NEW mode
    }

    get showAutofillFromPreviousForIncomeToggle(): boolean {
        return false; // No autofill options in NEW mode
    }

    get showBalanceSheetReportSelection(): boolean {
        return false; // No previous reports in NEW mode
    }

    get showIncomeStatementReportSelection(): boolean {
        return false; // No previous reports in NEW mode
    }

    constructor(formBuilder: FormBuilder, dateLocalePipe: DateLocalePipe) {
        super(formBuilder, dateLocalePipe);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.initializeNewMode();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes['setupData'] && this.setupData) {
            this.initializeNewMode();
        }
    }

    private initializeNewMode(): void {
        if (!this.setupData) return;

        // Set all relevant fields to disabled/enabled in new mode
        this.disableCompany = true;
        this.disableAccountingBasis = false;
        this.disableArTemplate = false;
        this.disableLanguage = false;
        this.disablePreviousSettings = false;
        if (this.setupData.reportType === ReportType.ANNUAL) {
            this.disableReportType = true;
        } else {
            this.disableReportType = false;
        }

        // Pre-select company from setup data
        const preselectedCompany = this.companies.find((c) => c._id === this.setupData?.company._id);
        if (preselectedCompany) {
            this.form.patchValue({ company: preselectedCompany });
        }

        // Pre-select report type from setup data
        const preselectedReportType = this.reportTypes.find((rt) => rt.id === this.setupData?.reportType);
        if (preselectedReportType) {
            this.form.patchValue({ reportType: preselectedReportType });
        }

        // Pre-fill dates from setup data
        if (this.setupData.balanceSheetDate) {
            const sheetDates = DatesCalculatorUtil.calculateFinancialStatementDates(
                this.setupData.balanceSheetDate,
                this.setupData.reportType,
            );

            this.form.patchValue({
                balanceSheetDate: sheetDates.balanceCurrentYearDate,
                balancePreviousYearDate: sheetDates.balancePreviousYearDate,
                incomeCurrentYearFromDate: sheetDates.incomeCurrentYearFromDate,
                incomeCurrentYearToDate: sheetDates.incomeCurrentYearToDate,
                incomePreviousYearFromDate: sheetDates.incomePreviousYearFromDate,
                incomePreviousYearToDate: sheetDates.incomePreviousYearToDate,
            });
        }

        // Update form control states after setting disabled flags
        this.updateFormControlStates();
    }
}
